import { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useNotification from '../../../../../../utils/hooks/useNotification';
import LoadingIndicator from '../../../../../../components/loading-indicator/LoadingIndicator';
import useCreate from '../../../../../../utils/hooks/crud-hooks/useCreate';

const OAuthLinkedInReview = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const { notify } = useNotification();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const code = query.get('code');
  const state = query.get('state');
  const error = query.get('error');
  const [localStorageData, setlocalStorageData] = useState({
    state: 'init',
    review: {
      caseStudyId: '',
      reviewData: {},
      token: '',
    },
  });

  const { mutate: submit } = useCreate({
    resource: `/case-studies/${localStorageData.review.caseStudyId}/submit-review-linkedin?token=${localStorageData.review.token}`,
  });

  useEffect(() => {
    try {
      const storageDataValue = localStorage.getItem('review');

      if (storageDataValue !== null) {
        const storageDataParsed = JSON.parse(storageDataValue);
        setlocalStorageData({ ...localStorageData, state: 'parsed', review: storageDataParsed });
      } else {
        setlocalStorageData({ ...localStorageData, state: 'parsed-not-found' });
        setErrorMessage('No review data fount. Please try again');
        setIsLoading(false);
      }
    } catch (error) {
      setlocalStorageData({ ...localStorageData, state: 'parsed-error' });
      setErrorMessage('No review data fount. Please try again');
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorageData.state === 'parsed') {
      if (code && state) {
        submit(
          { code, state, review: localStorageData.review.reviewData },
          {
            onSuccess: (data) => {
              localStorage.removeItem('review');
              navigate(`/case-study/${localStorageData.review.caseStudyId}/submit-review`);
            },
            onError: (error) => {
              let errorMessage = 'Error during LinkedIn authentication';

              if (
                typeof error !== 'string' &&
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                errorMessage += `: ${error.response.data.message}`;
              }
              notify.error(errorMessage);
              navigate(
                `/case-study-review-submit-public/${localStorageData.review.caseStudyId}/${localStorageData.review.token}`,
                { replace: true },
              );
            },
          },
        );
        return;
      }
      if (error) {
        notify.error('Error during LinkedIn authentication');
        navigate(
          `/case-study-review-submit-public/${localStorageData.review.caseStudyId}/${localStorageData.review.token}`,
          { replace: true },
        );
        return;
      }
      if (!code && !state && !error) {
        notify.error('Error during LinkedIn authentication');
        navigate(
          `/case-study-review-submit-public/${localStorageData.review.caseStudyId}/${localStorageData.review.token}`,
          { replace: true },
        );
      }
    }
  }, [code, error, localStorageData]);

  return (
    <Stack
      sx={{ height: '600px', width: '100%', pt: '10%' }}
      justifyContent="center"
      alignItems="center"
      spacing={20}
    >
      <Typography variant="h4" fontWeight={700} sx={{ mb: 5, mt: 5 }}>
        LinkedIn Authentication
      </Typography>

      {isLoading ? <LoadingIndicator /> : <Typography>{errorMessage}</Typography>}
    </Stack>
  );
};
export default OAuthLinkedInReview;
